// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"U0yjGs-mp-aGBdCHsFUNP"};